import { render } from "./InternalCommentWarningBtn.vue?vue&type=template&id=367b5de9&scoped=true"
import script from "./InternalCommentWarningBtn.vue?vue&type=script&lang=js"
export * from "./InternalCommentWarningBtn.vue?vue&type=script&lang=js"

import "./InternalCommentWarningBtn.vue?vue&type=style&index=0&id=367b5de9&scoped=true&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367b5de9"]])

export default __exports__